import React from 'react';
import {Page, StorePageCount} from "../../components/page/Page";
import {LoadingData} from "../../components/loading-data/LoadingData";
import {useOfficeStore} from "../../api/OfficeStore";
import {Office} from "../../api/Model";
import {OfficeTable} from "./OfficeTable";
import {useFormDialogAction} from "../../components/form-dialog/FormDialogProvider";
import {OfficeFormDialog} from "./OfficeFormDialog";
import {OfficeIconGallery} from "../../components/office-icon/OfficeIcon";

const showIconGallery: boolean = false

export default function OfficesPage() {
    const {
        remoteValue: offices,
        updateOffice,
    } = useOfficeStore();

    const handleEdit = useFormDialogAction({
        title: "Edit Office",
        description: "Update the office information below.",
        submitButtonText: 'Update',
        renderForm: OfficeFormDialog,
        action: (openDialog, office: Office) => openDialog({
            initialValue: {
                hibobResidence: office.hibobResidence,
                checkInsIntegrationEnabled: office.checkInsIntegrationEnabled,
                releezmeIntegrationEnabled: office.releezmeIntegrationEnabled,
            },
            onSubmit: form => updateOffice(office, form),
            successMessage: `Updated office ${office.name}.`,
            errorMessage: 'Failed to update office. Please try again later.',
        })
    }, [updateOffice]);

    return (
        <Page
            header="Offices"
            counter={<StorePageCount value={offices}/>}
            description="List of offices from Envoy"
        >
            {showIconGallery && <OfficeIconGallery fontSize="128px"/>}
            <LoadingData
                value={offices}
                emptyMessage="No offices found."
                defaultErrorMessage="Failed to load offices. Please try again later."
            >{resolved => (
                <OfficeTable rows={resolved} onEdit={handleEdit}/>
            )}</LoadingData>
        </Page>
    );
}
